import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'

import errors from '../../lib/errors.js'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import AgencyProducerCard from './AgencyProducerCard'
import AgencyProducerNotFound from './AgencyProducerNotFound'

import Resource from '../../stores/resource'
const AgProducerStore = Resource('agency-producers')

class ShowAgencyProducer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      agencyProducer: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    AgProducerStore.findBy({id: this.props.match.params.id}, ['agency'])
    .then((result) => this.setState({agencyProducer: result.data, loading: false}))
    .catch((error) => this.setState({agencyProducer: {}, error: errors.unpack(error), loading: false}))
  }

  _redirectTo = (url) => {
    this.setState({redirect: url})
  }

  render() {
    const {
      agencyProducer,
      redirect,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect}/>
    if (isEmpty(agencyProducer)) return <AgencyProducerNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            External project manager: <span className="mui--text-dark">{agencyProducer.name}</span>
          </PageTitle>
        </header>
        <AgencyProducerCard
          agencyProducer={agencyProducer}
          editCallback={() => this._redirectTo(`/agency-producers/${agencyProducer.id}/edit`)}
        />
        <br/>
        <BackButton/>
      </section>
    )
  }
}

export default ShowAgencyProducer



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/ShowAgencyProducerPage.jsx